import React, { createContext, useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Routers from "./Routers/Routers.jsx";
import "react-phone-input-2/lib/style.css";
import "react-responsive-pagination/themes/classic.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./App.css";
import persistStore from "redux-persist/es/persistStore";
import store from "./Redux/Store/Store.jsx";
import { PersistGate } from "redux-persist/integration/react";
import { useTranslation } from "react-i18next";
const persistor = persistStore(store);
export const GlobalData = createContext();

function App() {
  const [Userid, SetUserId] = useState(null);
  const [Collapsed, setCollapsed] = useState(false);

  const [CourseFilterData, SetCourseFilterData] = useState(null);
  const [FilterData, SetFilterData] = useState(false);
  const [data, setdata] = useState();
  const [Edit, SetEdit] = useState(false);
  const [Courseid, SetCourseId] = useState(null);
  const [previousPath, setPreviousPath] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const { i18n } = useTranslation();
  useEffect(() => {
    document.body.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <div className="App">
      <GlobalData.Provider
        value={{
          Collapsed,
          setCollapsed,
          setdata,
          data,
          Edit,
          SetEdit,
          SetUserId,
          Userid,
          SetCourseId,
          Courseid,
          SetCourseFilterData,
          CourseFilterData,
          FilterData,
          SetFilterData,
          showButton,
          setShowButton,
          previousPath,
          setPreviousPath,
        }}
      >
        <BrowserRouter>
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <Routers />
            </PersistGate>
          </Provider>
        </BrowserRouter>
      </GlobalData.Provider>
    </div>
  );
}

export default App;
